// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title-3BnUic1j"};